import React from 'react';
import styled from 'styled-components';
import { IconTooltip } from '~/components';
import { colors } from '~/styles';

const PreMessage = styled.div`
  white-space: pre-wrap;
  padding-top: 0.25rem;
`;

function AccountingNotesTooltip({ projects, spaceLeft, ...props }) {
  projects = [projects].flat().filter(({ accountingNotes }) => accountingNotes);
  if (!projects.length) return null;

  const multi = projects.length > 1;

  const message = () => {
    const notes = projects.map(({ id, name, accountingNotes }, index) =>
      multi ? (
        <React.Fragment key={id}>
          <strong>{name} </strong>
          <br />
          <i>{accountingNotes}</i>
          <br />
          {index !== projects.length - 1 && <br />}
        </React.Fragment>
      ) : (
        <i key={id}>{accountingNotes}</i>
      ),
    );

    return notes;
  };

  return (
    <IconTooltip
      icon="note"
      color={colors.grey25}
      message={
        <PreMessage>
          {
            <>
              <strong>Accounting Notes</strong>
              <div style={{ height: 1, backgroundColor: colors.grey10, margin: '0.25rem 0rem' }} />
              {message()}
            </>
          }
        </PreMessage>
      }
      maxWidth="30rem"
      style={{ marginLeft: spaceLeft ? '0.25rem' : 0 }}
      {...props}
    />
  );
}

export default AccountingNotesTooltip;
